export default __webpack_public_path__ + "static/media/Payroll_filled.1b470ca7.svg";